import { Order } from "../types/shopify";
import { RootState, store } from "../store";
import { handleUnauthorizedError } from "./apiMiddleware";

const API_BASE_URL = `${import.meta.env.VITE_API_URL || "http://localhost:5000/api"}/reporting`;

const getAuthToken = (): string | null => {
  const state = store.getState() as RootState;
  return state.user.currentUser?.token || null;
};

const getAuthHeaders = (): HeadersInit => {
  const token = getAuthToken();
  const headers: HeadersInit = {
    "Content-Type": "application/json",
  };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  return headers;
};

export const getFilteredOrdersByLocationAndDateRange = async (
  startDate: string,
  endDate: string,
  locationId?: string
): Promise<Order[]> => {
  const body: any = { startDate, endDate };
  if (locationId) body.locationId = locationId;

  const response = await fetch(`${API_BASE_URL}/orders`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
  });

  if (handleUnauthorizedError(response)) {
    throw new Error("Unauthorized");
  }

  if (!response.ok) {
    throw new Error(`HTTP error ${response.status}`);
  }

  const data = await response.json();
  return data.orders as Order[];
};

export const getSupplierPurchaseOrders = async (params?: {
  startDate?: string;
  endDate?: string;
  retailerId?: string | null;
  supplierId?: string | null;
  syncPennylane?: boolean;
}): Promise<any[]> => {
  const query = new URLSearchParams();
  if (params?.startDate) query.set("startDate", params.startDate);
  if (params?.endDate) query.set("endDate", params.endDate);
  if (params?.retailerId) query.set("retailerId", params.retailerId);
  if (params?.supplierId) query.set("supplierId", params.supplierId);
  if (params?.syncPennylane !== undefined) {
    query.set("syncPennylane", params.syncPennylane ? "1" : "0");
  }

  const response = await fetch(
    `${API_BASE_URL}/supplier-purchase-orders${query.toString() ? `?${query.toString()}` : ""}`,
    {
      headers: getAuthHeaders(),
    }
  );

  if (handleUnauthorizedError(response)) {
    throw new Error("Unauthorized");
  }

  if (!response.ok) {
    throw new Error(`HTTP error ${response.status}`);
  }

  return await response.json();
};
